module.exports = __webpack_public_path__ + "img/b2b-logo-mobile.fbe5edb1.png";